import { FORMATS } from './views/ExportModal';

// Export submissions runs on the worker (useFormSubmissionsExport): the
// mutation's input from the dialog's choice plus the page's search and
// sort, and the toast once the file has downloaded.

// The browser's IANA zone, so dates in the file read as they do on screen.
// Undefined when the browser can't say; the server then uses its default.
export const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch (e) {
    return undefined;
  }
};

// → ExportFormSubmissionsInput. The search goes along only when the person
// chose the entries matching it.
export const exportRunInput = ({
  formId,
  fmt,
  cols,
  scope,
  search,
  sort,
  timeZone = browserTimeZone(),
}) => ({
  form_id: formId,
  format: String(fmt || 'csv').toUpperCase(),
  keys: cols,
  sort: sort.key,
  direction: sort.direction,
  ...(scope === 'matching' && search ? { search } : {}),
  ...(timeZone ? { timezone: timeZone } : {}),
});

const plural = (count, word) =>
  `${count.toLocaleString()} ${word}${count === 1 ? '' : 's'}`;

// "Excel downloaded · 1,204 rows"
export const exportedToast = (fmt, rows) => {
  const format = FORMATS.find((f) => f.id === fmt) || FORMATS[0];
  return {
    type: 'success',
    title: `${format.label} downloaded · ${plural(rows || 0, 'row')}`,
  };
};
